import { c as _c } from "react/compiler-runtime";
export const IconCar = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="m20.772 9.155-1.368-4.104a2.995 2.995 0 0 0-2.845-2.05H7.441a2.995 2.995 0 0 0-2.845 2.05L3.228 9.155A2 2 0 0 0 2 11v5c0 .738.404 1.376 1 1.723V20a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-2h12v2a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-2.277A1.99 1.99 0 0 0 22 16v-5a2 2 0 0 0-1.228-1.845ZM7.441 5h9.117c.431 0 .813.274.949.684L18.613 9H5.387l1.105-3.316A1 1 0 0 1 7.441 5ZM5.5 15a1.5 1.5 0 1 1 .001-3 1.5 1.5 0 0 1-.001 3Zm13 0a1.5 1.5 0 1 1 .001-3 1.5 1.5 0 0 1-.001 3Z" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
IconCar.displayName = 'IconCar';